/**
 * @function NoEntriesTableRow
 * @param {STRING} className - Allows us to set a custom className. 
 * @param {STRING} text - Allows us to set a text. 
 * @param {INT} colSpan - Allows us to set the colspan number, default is 1.
 * @returns {React.Component}
 * @example
 *  <NoEntriesTableRow colSpan="3" text="No entries." />
 */
export function NoEntriesTableRow(props) {
    const className = props.className ?? "";
    const colSpan = props.colSpan ?? 1;
    const text = props.text ?? "There are no entries.";
    
    return (
      <tr className={`no-entries-table-row ${className}`}>
        <td colSpan={colSpan} className="no-entries text-center">
              <span>
                {text}
              </span>
          </td>
      </tr>
    );
  }